import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export interface AuthPasswordFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  autoComplete?: string;
  hint?: string;
  error?: string;
}

export function AuthPasswordField({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  autoComplete,
  hint,
  error,
}: AuthPasswordFieldProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="auth-field">
      <label htmlFor={id} className="auth-field__label">
        {label}
        {required ? <span className="req">*</span> : null}
      </label>
      <div className="auth-password-wrap">
        <input
          type={visible ? 'text' : 'password'}
          id={id}
          className="auth-field__input"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={required}
        />
        <button
          type="button"
          className="auth-password-toggle"
          onClick={() => setVisible((prev) => !prev)}
          aria-label={visible ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`}
        >
          {visible ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
      {hint ? <p className="auth-field__hint">{hint}</p> : null}
      {error ? <p className="auth-field__error">{error}</p> : null}
    </div>
  );
}

export default AuthPasswordField;
